<script setup>
import { ref } from 'vue';
import { useIntersectionObserver } from '@vueuse/core';

const target = ref(null);
const shouldLoad = ref(false);

const { stop } = useIntersectionObserver(
	target,
	([{ isIntersecting }]) => {
		if (isIntersecting) {
			shouldLoad.value = true;
			stop();
		}
	},
	{
		rootMargin: '200px',
	},
);
</script>

<template>
	<div ref="target">
		<slot v-if="shouldLoad"></slot>
		<div v-else style="min-height: 1px"></div>
	</div>
</template>
